import React from 'react'
// import Navbar from './Navbar'
import thank from './images/thank-you.jpg'
import Footer from './Footer'
import './Confirmation.css'
// import Navbar from './Navbar'

const Confirmation = () => {
  return (
    <>
    <div className='toto'>
      {/* {Navbar} */}
      <img src={thank} alt="" />

    </div>
    {/* <Navbar/> */}
    <div className="kiki">
    <Footer/>
    </div>
    </>

  )
}

export default Confirmation
